import styled, { css } from 'styled-components'

import { MEDIA } from 'utils/constants'

const { MOBILE_UP, MOBILE, DESKTOP_UP } = MEDIA

export const CategoryBox = styled.div`
  border-radius: 50%;
  width: 7rem;
  height: 7rem;
  overflow: hidden;
  padding: 0;
  margin: 0;

  img {
    position: relative;
    display: block;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
export const HeaderContent = styled.div`
  margin-bottom: 15px;
  h2{
    font-size:20px;
    line-height:24px;
    letter-spacing: 0.96px;
    font-weight:600;
    color:var(--gray-2);
    font-family: var(--primary-font);
  }
  ${props => props.withMarginTop && 'margin-top: 30px'}
`
export const CheckList = styled.div`
  margin-left: 24px;
  div {
    margin: 20px 0px;
    label {
      color: var(--gray-5);
      font-family: var(--primary-font);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 145%;
    }
  }
`
export const StepContainer = styled.div`
  margin-top: ${props => props.noCard ? '54px' : '-24px'};
  max-width: 100%;
  @media screen and ${MOBILE_UP} {
    max-width: ${props => props.noCard ? '100%' : '65%'};
    margin-top: ${props => props.noCard ? '54px' : '32px'};
  }
`
export const ProfessionalCheckContainer = styled.div`
  min-height: 30px;
  font-weight:bold;
`
export const LabelConfig = styled.div`
  font-size: 15px;
  width: 100%;
`
export const Position = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  ${props => props.fullWidth && 'flex-basis: 100%;'}
`
export const Row = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  ${props => props.flexWrap && 'flex-wrap: wrap'}
`
export const Space = styled.div`
  margin-top: 15px;
`

export const TimeList = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 1rem;
  background: var(--the-white);
  border-radius: 5px;
  overflow: hidden;

  @media screen and ${MOBILE} {
    width: calc(100% + 30px);
    margin-left: -15px;
  }
`
export const TimeTitle = styled.div`
  background: var(--cobasi-blue);
  color: var(--the-white);
  font-family: var(--primary-font);
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 25px;
  width: 100%;
  margin-bottom: 15px;
`
export const TimeCard = styled.button`
  flex-basis: 12.5%;
  max-width: 12.5%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-5);
  background: transparent;
  border: none;

  ${props => props.disabled && 'color: var(--silver); pointer-events: none;'}

  @media screen and ${MOBILE} {
    flex-basis: 20%;
    max-width: 20%;
  }
`
export const Time = styled.div`
  font-family: var(--primary-font);
  border-radius: 50%;
  font-size: 13px;
  font-weight: 600;
  width: 55px;
  height: 55px;
  line-height: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled {
    color: var(--silver);
  }

  &:hover{
    background: transparent;
    color: var(--cobasi-orange-2);
    border: 1px solid var(--cobasi-orange-2);
  }

  @media screen and ${MOBILE} {
    width:51px;
    height:51px;
    font-size: 13px;
  }
`
export const TitleCalendar = styled.span`
  strong{
    margin-left: 5px;
    font-weight: 600;
  }
`
export const TitleTime = styled.span`
  strong{
    margin-left: 5px;
    font-weight: 600;
  }
`
export const PositionRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 1em;
  cursor:pointer;
  align-items:center;
`
export const H6 = styled.div`
  color: var(--cobasi-blue-light-4);
  font-size: 13px;
  text-decoration: underline;
  font-weight: 600;
  font-family: var(--primary-font);
`

export const SpanProfessional = styled.div`
  letter-spacing: 0px;
  color: var(--schedule-gray);
  font-size: 13px;
  font-weight: normal;
  font-family: var(--secondary-font);
`
export const LabelProfessional = styled.div`
  color: var(--schedule-blue);
  font-size: 14px;
  font-weight: bold;
  font-family: var(--secondary-font);

  label {
    cursor: pointer;
  }

  @media screen and ${MOBILE} {
    position: absolute;
    top: 0;
    right: 0;
    align-self: baseline;
    margin-top: 0px;
  }
`

export const AccordionSize = styled.div`
  width: 100%;
`
export const SpaceContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px 15px;
  justify-content: space-between;
  font-family: var(--primary-font);
  font-size: 13px;

  &:last-of-type {
    margin-bottom: 7px;
  }
`
export const LabelSize = styled.div`
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.96px;
  color: ${props => props.color ? props.color : 'var(--gray-5)'};
`
export const LabelSizePrice = styled(LabelSize)`
  float: right;
  margin-left: 0;
  color: ${props => props.color ? props.color : 'var(--gray-5)'};
  font-size: 16px;
  font-weight: 600;
`
export const PriceSeparator = styled.div`
  flex-basis: 100%;
  height: 1px;
  background-color: ${props => props.color ? props.color : 'var(--gray-5)'};
`
export const PriceObservation = styled.label`
  font-size: 14px;
  margin-left: 15px;
  font-family: var(--primary-font);
  font-weight: normal;
  color: var(--schedule-gray);
`
export const Phone = styled.label`
  display: flex;
  align-items: start;
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 600;
  margin-top: 10px;
  letter-spacing: 1px;
  line-height: 20px;
  color: var(--gray-5);

  img {
    width: 20px;
    height: 21px;
    margin-right: 10px;
  }
`
export const List = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`
export const Error = styled.span`
  font-size: 15px;
  color: red;
`
export const ErrorSpace = styled.div`
  margin-top: 15px;
`
export const ErrorPetSpace = styled.div`
  margin-top: 15px;
  text-align: center;
`

export const Content = styled.div`
  @media screen AND ${DESKTOP_UP}{
    width: 100%;
  }
`

export const Step = styled.span`
  h2{
    font-size: 20px;
    font-weight: 600;
  }
  font-family: var(--secondary-font);
  font-style: normal;
  line-height: 120%;
  letter-spacing: 0.96px;
  color: var(--gray-2);
  font-family: var(--secondary-font);
`
export const ModalMessageContact = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > * {
    margin: 5px 0;
  }

  @media screen and ${MOBILE_UP} {
    flex-direction: row;

    & > * {
      margin: 5px 7px;
    }
  }
`

export const CalendarNavigationButton = styled.span`
  padding: 16px 24px;
`

export const Captions = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0 0 5px 5px;
  padding: ${props => props.padding ? props.padding : '30px 50px 30px 50px'};
  background: var(--the-white);
  flex-wrap: wrap;
  margin-top: -3px;

  @media screen and ${MOBILE} {
    padding: 25px 0px;
    width: calc(100% + 30px);
    margin-left: -15px;
  }
`
export const Caption = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--primary-font);
  font-weight: normal;
  font-size: 13px;
  color: ${props => props.bg ? `var(${props.bg})` : 'var(--gray-5)'};
  margin-bottom: 10px;
  margin-right: 35px;

  ${props => (props.hasDot && CaptionDot)}

  @media screen and ${MOBILE} {
    margin-right: 0px;
    margin-left: 18px;
    justify-content: flex-start;
  }
`

const CaptionDot = css`
  &::before {
    background: ${props => props.bg ? `var(${props.bg})` : 'var(--gray-5)'};
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 8px;
  }
`
export const PromoCaption = styled.div`
  margin-bottom: 10px;
  padding: 0px 8px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--primary-font);
  font-weight: normal;
  font-size: 13px;
  color: var(--success);
  background-color: var(--success-pastel);
  border-radius: 32px;

  @media screen and ${MOBILE} {
    margin-left: 18px;
  }
`
export const RowCustomAddress = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  margin-top:29px;

  h5{
    margin-bottom:5px;
  }
`

export const ButtonUsePet = styled.button`
  border:none;
  background:none;
  cursor: pointer;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  margin-right:50px;

  span{
    font-size:15px;
    color:var(--cobasi-blue-light-4);
    font-weight:700;
    font-family: var(--primary-font);
    margin-top:5px;
  }

  @media screen and ${MOBILE} {
    margin-right: 25px;
  }
`
export const CircleUserPet = styled.div`
  background:var(--cobasi-blue-light-4);
  border-radius:50%;
  width:64px;
  height:64px;
  display:flex;
  align-items:center;
  justify-content:center;
`
export const IconUsetPet = styled.img`
  max-width:100%;
  margin-top:5px;
`

export const ModalTitle = styled.h1`
  color: ${props => props.textColor ? `${props.textColor}` : 'var(--gray-2)'};
  font-family: var(--primary-font);
  font-weight: ${props => props.fontWeight ? `${props.fontWeight}` : 600};
  display: block;
  font-size: 16px;
  line-height: 120%;

  @media screen and ${MOBILE} {
    span {
      display: block;
    }
  }
`

export const ModalInfo = styled.span`
  font-family: var(--primary-font);
  font-weight: 400;
  display: block;
  font-size: 14px;
  text-align: ${props => props.ta ? `${props.ta}` : 'center'};
  white-space: pre-line;
  line-height: 145%;
  margin: 0px;

  &:first-child {
    margin-bottom: ${props => props.noMarginBottom ? '0px' : '16px'};
  }

  @media screen and ${MOBILE} {
    line-height: 20.3px;
  }
`

export const ModalSmallInfo = styled.span`
  font-family: var(--secondary-font);
  display: block;
  font-size: 13px;
`

export const LabelStamp = styled.div`
  position: absolute;
  right: 60px;
  top: -7px;
`

export const SchedulingActions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;

  button {
    width: ${props => props.isButtonWide ? '215px' : '130px'};
  }

  @media screen and ${MOBILE} {
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 16px;
    flex-direction: column-reverse;

    button {
      margin: 0px;
      width: 100%;
    }
  }
`

export const GridContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 48px;
  padding: 24px 16px;
  @media screen and ${MOBILE} {
    grid-template-columns: repeat(2, 1fr);
    strong {
      display: block;
    }
  }
`

export const SchedulingAccordionItem = styled.div`
color: var(--gray-2);
font-family: var(--primary-font);
font-weight: 400;
font-size: 16px;
strong {
  letter-spacing: 0.96px;
  font-weight: 600;
}
`

export const SchedulingAccordionEdit = styled.div`
  position: absolute;
  bottom: 5px;
  right: 20px;
  cursor: pointer;
`

export const MessageGroup = styled.div`
  width: 100%;
  margin-top: 20px;
`

export const WarningMessage = styled.div`
  width: fit-content;
  background-color: var(--clean-gray);
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.96px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 13px;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  -o-border-radius: 4px;
  margin-bottom: 5px;

  svg {
    min-width: 19px;
    border: 2px solid var(--dark-yellow);
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    -o-border-radius: 50%;
    padding: 2px;
    margin-right: 10px;
  }
`

export const InfoMessage = styled.div`
  width: fit-content;
  background-color: transparent;
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.96px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;

  svg {
    min-width: 19px;
    border: 2px solid var(--navy-blue);
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    -o-border-radius: 50%;
    padding: 2px;
    margin-right: 10px;
  }

  @media screen and ${MOBILE} {
    margin-top: 10px;
  }
`

export const ScheduleBox = styled.div`
  border: 1px solid var(--gray-9);
  color: var(--gray-5);
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  -o-border-radius: 4px;
  padding: 10px 16px;
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.96px;
  margin: 25px 40px;
  line-height: 18px;

  @media screen and ${MOBILE} {
    margin: 20px 0px;
  }
`

export const WrapperContinue = styled.div`
  width: 100%;

  @media screen and ${MOBILE} {
    ${props => props.hide && css`
      display: none;
    `};
  }
`

export const CardInvertSteps = styled.div`
  box-sizing: border-box;
  margin-top: 24px;

  @media screen and ${MOBILE} {
    width: 100%;
    justify-content: flex-end;
  }
`

export const CardBodyInvertSteps = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media screen and ${MOBILE} {
    justify-content: space-between;
    align-items: center;
  }
`

export const CardContentInvertSteps = styled.div`
  width: ${props => props.toDecrease ? '50%' : '100%'};
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
  align-items: center;
  h2 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.96px;
    color: var(--gray-2);
  }

  p {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 145%;
    color: var(--gray-5);
  }

  @media screen and ${MOBILE} {
    width: 100%;
    justify-content: start;
  }
`

export const RadioGroup = styled.div`
  margin-top: 2rem;
  max-width: 25rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  div > label {
    font-family: var(--primary-font);
    font-weight: 400;
    font-size: 14px;
    color: var(--gray-5);
  }
`

export const WrapperTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`

export const Tag = styled.div`
  height: 24px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0 12px;
  background-color: var(--neutral-gray);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
`
